import { authSelectors } from '@web/app/features/auth'
import { routeTree } from '@web/routeTree.gen'
import { Spinner } from '@kit/ui'
import {
  createRouter,
  ErrorComponent,
  RouterProvider as TSRouterProvider,
} from '@tanstack/react-router'
import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
// IMPORTANTE: Importa el hook del perfil (ajusta la ruta si es necesario)
import { useGetProfileQuery } from '@web/app/features/profile/store' 

export interface AuthData {
  userId?: string
  role?: string
  isAuthenticated?: boolean
  userProfile?: any // <--- Agregamos esto
  dispatch?: ReturnType<typeof useDispatch>
}
export interface RouterContext extends AuthData {}

const router = createRouter({
  routeTree,
  defaultPendingComponent: () => <Spinner />,
  defaultErrorComponent: ({ error }) => <ErrorComponent error={error} />,
  context: {
    isAuthenticated: false, // Contexto inicial vacío
  } as RouterContext,
  scrollRestoration: true,
})

export type WebAppRouter = typeof router

export function RouterProvider() {
  const dispatch = useDispatch()
  const { user_id, role, token } = useSelector(authSelectors.authData)
  
  // Obtenemos los datos frescos del perfil
  // skip: !!token asegura que solo intente pedir el perfil si hay un token
  const { data: userProfile } = useGetProfileQuery(undefined, { skip: !token })

  const contextValue = useMemo(() => {
    return {
      userId: user_id,
      role: role,
      isAuthenticated: !!token,
      userProfile: userProfile, // <--- Inyectamos el perfil aquí
      dispatch,
    }
  }, [user_id, role, token, userProfile, dispatch])

  return <TSRouterProvider router={router} context={contextValue} />
}